export default __webpack_public_path__ + "static/media/Flag_of_Tunisia.e0e889d9.svg";